<template>
  <div>
    <f-row
      class="wrapper"
      ref="wrapper"
      :style="{
        transform: `translateX(-${index * (swiperItemWidth + gap)}px)`,
      }"
    >
      <slot></slot>
    </f-row>
    <f-row class="control-wrapper" justify="space-between" aligner="middle">
      <div class="progress">
        <div
          class="progress-slider"
          :style="{
            width: `${sliderWidth}px`,
            transform: `translateX(${index * sliderWidth}px)`,
          }"
        ></div>
      </div>
      <div class="page-turn-button">
        <img
          @click="pre"
          :class="['pre', 'page-btn', index === 0 ? 'disabled' : '']"
          src="@/assets/images/design-arrow.webp"
          alt=""
        />
        <img
          @click="next"
          :class="['next', 'page-btn', index === c_total - 1 ? 'disabled' : '']"
          src="@/assets/images/design-arrow.webp"
          alt=""
        />
      </div>
    </f-row>
  </div>
</template>
<script>
export default {
  emits: ['click'],
  props: {
    total: {
      type: Number,
      default: 7,
    },
    gap: {
      type: Number,
      default: 25,
    },
    activeIndex: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      progressWidth: 0,
      swiperItemWidth: 0,
      wrapperWidth: 0,
    }
  },
  computed: {
    index() {
      return this.activeIndex
    },
    sliderWidth() {
      return (1 / this.c_total) * this.progressWidth
    },
    // pc端少点击一次
    c_total() {
      return this.total
    },
  },
  mounted() {
    this.resizeChange()
    window.addEventListener('resize', this.resizeChange)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeChange)
  },
  methods: {
    pre() {
      if (this.index === 0) return
      this.$emit('update:activeIndex', this.index - 1)
    },
    next() {
      if (this.index === this.c_total - 1) return
      this.$emit('update:activeIndex', this.index + 1)
    },
    resizeChange() {
      this.progressWidth = document.querySelector('.progress').clientWidth
      this.swiperItemWidth =
        document.querySelector('.swiper-item-card').clientWidth

      this.wrapperWidth = document.querySelector('.wrapper').clientWidth
    },
  },
}
</script>
<style scoped lang="less">
.wrapper {
  margin-left: 24px;
  transition: all 0.4s ease;
  > div {
    flex-grow: 0;
    flex-shrink: 0;
  }
}
.control-wrapper {
  margin-top: 25px; /* rc sm:48px; */
  flex-wrap: wrap; /* rc:extract sm; */
  display: flex;
  justify-content: center;
}
.progress {
  width: 90vw; /* rc:only sm:100%; */
  height: 4px;
  background: #292524;
  border-radius: 4px;
  .progress-slider {
    background: #7d7777;
    height: 100%;
    border-radius: 4px;
    transition: all 0.4s ease;
  }
}
.page-turn-button {
  display: flex;
  margin-top: 24px;
  .page-btn {
    width: 48px; /* rc sm:40px; */
    border-radius: 50%;
    background: #7d7777;
    cursor: pointer;
    &.disabled {
      background: #292524;
      cursor: not-allowed;
    }
  }
  .next {
    transform: rotateZ(180deg);
    margin-left: 13px;
  }
}
</style>
